import type { GridProps } from '@gonfalon/ui/grid';
import { Cell, Grid } from '@gonfalon/ui/grid';
import { Skeleton } from '@gonfalon/ui/skeleton';

export function GridSkeleton(props: GridProps) {
  return <Grid {...props} aria-label="loading" aria-valuetext="loading" role="progressbar" />;
}

export function SkeletonCells({ cells, className, testId }: { cells: number; className?: string; testId?: string }) {
  return (
    <>
      {Array.from({ length: cells }, (_, key) => (
        <Cell key={key} className={className} testId={testId}>
          <SkeletonCellContent />
        </Cell>
      ))}
    </>
  );
}

export function SkeletonCellContent() {
  return <Skeleton height="var(--lp-size-44)" />;
}
